import * as angular from "angular";
import {IController} from "angular";

export class BillingOrdersViewSettingsPanelTemplateCtrl implements IController {

  settings: any;
  panelRef: any;

  public settingsCopy: any;
  public enabledSections: any;

  $onInit() {
    this.settingsCopy = angular.copy(this.settings);
    this.enabledSections = {
      columns: true,
      viewSettings: false
    }
  }

  onColumnsChange(columns) {
    this.settingsCopy.columns = columns;
  }

  onChangeColumns(columnKey, isEnabled) {
    this.settingsCopy.columns[columnKey].enabled = isEnabled;
  }

  onToggleIsOpenColumns(isOpen) {
    this.enabledSections.columns = !this.enabledSections.columns;
  }

  onToggleIsOpenViewSettings(isOpen) {
    this.enabledSections.viewSettings = !this.enabledSections.viewSettings;
  }

  onSubmit() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Submit', this.settingsCopy);
  }

  onReset() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Reset');
  }

  onCancel() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Cancel');
  }

}

angular
.module('bringoz.admin.billing-accounts')
.component('billingOrdersViewSettingsPanelTemplate', {
  bindings: {
    settings: '<',
    panelRef: '<'
  },
  template: require('./billing-orders-view-settings-panel-template.html').default,
  controller: BillingOrdersViewSettingsPanelTemplateCtrl
});
